import iIsaac from "./Isaac-Were.jpg";
import iDoreen from "./Doreen-Kansiime.jpg";
import iBrian from "./Brian-Ssemate.jpg";
import iDorine from "./Dorine-Sanyu.jpg";
import iElly from "./Elly-Yiga.jpg";
import iFrancis from "./Francis-Kyagulanyi.jpg";
import iJerry from "./Jerry-Vance-Anguzu.jpg";
import iJuliet from "./Juliet-Laker.jpg";
import iMichael from "./Micheal-Kibande.jpg";
import iOshin from "./Oshin-Were.jpg";
import iSasha from "./Sasha-Sauda.jpg";
import iShamilah from "./Shamilah-Hatibu.jpg";
import iSam from "./Sam-Ellis.jpg";
import iPatrick from "./Patrick-Lwanga.jpg";

export const IsaacImg = iIsaac;
export const DoreenImg = iDoreen;
export const BrianImg = iBrian;
export const DorineImg = iDorine;
export const EllyImg = iElly;
export const FrancisImg = iFrancis;
export const JerryImg = iJerry;
export const JulietImg = iJuliet;
export const MichaelImg = iMichael;
export const OshinImg = iOshin;
export const SashaImg = iSasha;
export const ShamilahImg = iShamilah;
export const SamImg = iSam;
export const PatrickImg = iPatrick;
